export * from './lib/search-feature-shell.module';
